/**
 * useExperts Hook
 * React Query hook for fetching experts list
 */

import { useQuery } from "@tanstack/react-query"
import * as connectService from "../services/connect.service"

export function useExperts(params?: {
  page?: number
  limit?: number
  search?: string
  city?: string
  state?: string
  country?: string
}) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["connect-experts", params],
    queryFn: () => connectService.getExperts(params),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    experts: data?.experts ?? [],
    pagination: data?.pagination,
    isLoading,
    error,
  }
}
